<template>
  <b-modal ref="mdlDocumentiEditModal" modal-class="sa-modal-static-scroll" title="Documento" size="xl"
    @shown="onShownModal" :no-close-on-backdrop="true" :no-close-on-esc="true">
    <div class="sa-free-page">
      <div class="sa-free-page-header">
        <contabilita-documento-dati-edit-compontent ref="cmpContabilitaDocumentoDatiEditCompontent"
          @update="onUpdateContabilitaDocumentoDatiEditCompontent" />
      </div>
      <div class="sa-free-page-body">
        <contabilita-documento-righe-edit-component :jsonData="jsonData" ref="cmpContabilitaDocumentoRigheComponent"
          @update="onUpdateContabilitaRigheDocumento" />
      </div>
    </div>
    <template #modal-footer>
      <div class="sa-padding-right text-right col">
        <b-button type="button" variant="secondary" @click="hide()">Chiudi</b-button>
        <b-button type="button" variant="success" @click="onOkModal">Salva Documento</b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
import ContabilitaDocumentoDatiEditCompontent from "../components/ContabilitaDocumentoDatiEditCompontent.vue";
import ContabilitaDocumentoRigheEditComponent from "../components/ContabilitaDocumentoRigheEditComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
  mixin: [UtilityMixin],
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  components: { ContabilitaDocumentoDatiEditCompontent, ContabilitaDocumentoRigheEditComponent },
  props: {
    idAccettazione: { type: String },
  },
  data() {
    return {
      jsonData: {
        documentiCollegati: []
      },
      accettazioneJson: {},
      armadiettoPaziente: [],
      pathResource: "/contabilitadocumenti",
    };
  },
  methods: {
    init(jsonData) {
      this.jsonData = jsonData;

      this.show();
    },
    show() {
      this.$refs.mdlDocumentiEditModal.show();
    },
    onShownModal() {
      this.$refs.cmpContabilitaDocumentoDatiEditCompontent.init(this.jsonData);
      this.$refs.cmpContabilitaDocumentoRigheComponent.init(this.jsonData);
    },
    onOkModal(evt) {
      evt.preventDefault();
      this.openShowModalLoading();
      UtilityMixin.methods.restCallPost(process.env.VUE_APP_PATH_API + this.pathResource, this.jsonData, this.onOkModalSuccess, this.onOkModalError);
    },
    onOkModalSuccess(response) {
      this.closeShowModalLoading();
      response;
      this.$emit("afterSave");
    },
    onOkModalError(error) {
      this.closeShowModalLoading();
      this.$emit("afterSaveError", error);
    },
    hide() {
      this.$refs.mdlDocumentiEditModal.hide();
      this.resetJsonData();
    },
    onUpdateContabilitaDocumentoDatiEditCompontent(jsonData) {
      this.jsonData = { ...jsonData };
    },
    onUpdateContabilitaRigheDocumento(righeDocumento) {
      for (let riga of righeDocumento) {
        delete riga._showDetails;
      }
      this.jsonData.righeDocumento = [...righeDocumento];
    },
    resetJsonData() {
      this.jsonData = {};
    },
  },
};
</script>

<style scoped></style>
